import { HasId } from '../common';
import { UserId } from '../user/User';

export type IntroName = 'apps' | 'build' | 'learn' | 'plan' | 'report' | 'video';

export interface GuidedTour extends HasId {
    apps: boolean;
    build: boolean;
    learn: boolean;
    plan: boolean;
    report: boolean;
    video: boolean;

    userId: UserId;
}

export const guidedTourIntros: ReadonlyArray<IntroName & keyof GuidedTour> = [
    'apps',
    'build',
    'learn',
    'plan',
    'report',
    'video',
];

export interface CompleteGuidedTourIntroBody {
    introName: IntroName;
}

// These selectors are shared by the frontend and the E2E tests.
export const INTRO_CSS_SELECTORS = {
    build: {
        contentBuilder: {
            buttonSchedule: '.btn-build-schedule',
            textarea: 'textarea',
        },
        gallery: {
            plannersReadyToBuildBar: '#plannersReadyToBuildBar',
            templateThumbnail: '.template-thumbnail',
        },
    },
    learn: {
        pageTitle: '#pageTitle',
        searchText: '.search-text',
    },
    navbar: {
        build: '.menu-build',
        learn: '.menu-learn',
        plan: '.menu-plan',
        profileDropdownToggle: '#profileDropdownToggle',
        report: '.menu-report',
    },
    plan: {
        calendar: {
            calendarLegend: '#calendarLegend',
            dateCell: '.cell-date-11',
            legendEntryCalDanger: '.legend-entry.cal-danger',
            legendEntryCalDefault: '.legend-entry.cal-default',
            legendEntryCalSuccess: '.legend-entry.cal-success',
            legendEntryCalSupported: '.legend-entry.cal-supported',
            legendEntryCalWarning: '.legend-entry.cal-warning',
        },
        plannerEvent: {
            activity: '#form-activity',
            buttonBuildLater: '#btn-build-later',
            buttonBuildNow: '#btn-build-now',
            buttonContentRequired: '#btn-content-required',
            text: '#form-text',
            title: '#form-title',
            upload: '#form-upload',
        },
    },
    report: {
        buttonSearch: '.search-button button',
        endDate: '#form-group-end-date',
        startDate: '#form-group-start-date',
    },
};
